<template>
  <div class="header">
    <!-- 头部 -->
    <header>
      <div class="header-bottom">
        <p>
          {{ $t("message.christmas.titleZH") }}
          <template v-if="this.$i18n.locale === 'zh'">
            <!-- <router-link
              :to="{
                path: '/menu/',
                params: { lang: this.$i18n.locale }
              }"
              ><el-button type="primary" size="mini"
                >{{ $t("message.topbtn") }}
              </el-button></router-link
            > -->
            <a href="https://cateraway.rakosell.com/zh">
              <el-button type="primary" size="mini"
                >{{ $t("message.topbtn") }}
              </el-button>
            </a>
          </template>
          <template v-else>
            <!-- <router-link
              :to="{
                path: '/en/menu/',
                params: { lang: this.$i18n.locale },
              }"
              ><el-button type="primary" size="mini"
                >{{ $t("message.topbtn") }}
              </el-button></router-link
            > -->
            <a href="https://cateraway.rakosell.com/zh">
              <el-button type="primary" size="mini"
                >{{ $t("message.topbtn") }}
              </el-button>
            </a>
          </template>
        </p>
        <div class="center">
          <div style="display: flex;align-items:center;">
            <div class="h-bottom-l">
              <router-link v-if="this.$i18n.locale === 'zh'" to="/">
                <img src="../assets/images/pc_nav_logo.png" alt />
              </router-link>
              <router-link v-else to="/en/">
                <!-- pc_nav_logo -->
                <img src="../assets/images/pc_nav_logo.png" alt />
              </router-link>
              <ul>
                <template v-if="this.$i18n.locale === 'zh'">
                  <router-link to="/menu/">
                    <li>{{ $t("message.nav.attend") }}</li>
                  </router-link>
                  <router-link to="/equiry/">
                    <li>{{ $t("message.nav.activity") }}</li>
                  </router-link>
                  <router-link to="/corporate-catering/">
                    <li>{{ $t("message.nav.cooperation") }}</li>
                  </router-link>
                  <router-link to="/contact/">
                    <li>{{ $t("message.nav.contact") }}</li>
                  </router-link>
                  <router-link to="/client/">
                    <li>{{ $t("message.client.nav") }}</li>
                  </router-link>
                </template>
                <template v-else>
                  <router-link to="/en/menu/">
                    <li>{{ $t("message.nav.attend") }}</li>
                  </router-link>
                  <router-link to="/en/equiry/">
                    <li>{{ $t("message.nav.activity") }}</li>
                  </router-link>
                  <router-link to="/en/corporate-catering/">
                    <li>{{ $t("message.nav.cooperation") }}</li>
                  </router-link>
                  <router-link to="/en/contact/">
                    <li>{{ $t("message.nav.contact") }}</li>
                  </router-link>
                  <router-link to="/en/client/">
                    <li>{{ $t("message.client.nav") }}</li>
                  </router-link>
                </template>
              </ul>
              <el-dropdown>
                <div class="el-dropdown-link">{{ $t("message.nav.party") }}</div>
                <el-dropdown-menu slot="dropdown">
                  <template v-if="this.$i18n.locale === 'zh'">
                    <el-dropdown-item>
                      <router-link to="/party-food/">{{
                        $t("message.nav.party")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/christmas-party/">{{
                        $t("message.nav.christmas")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/birthday-party/">{{
                        $t("message.nav.birthday")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/junk-catering/">{{
                        $t("message.nav.boat")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/wedding-catering/">{{
                        $t("message.nav.wedding")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/halloween/">{{
                        $t("message.nav.halloween")
                      }}</router-link>
                    </el-dropdown-item>
                  </template>
                  <template v-else>
                    <el-dropdown-item>
                      <router-link to="/en/party-food/">{{
                        $t("message.nav.party")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/christmas-party/">{{
                        $t("message.nav.christmas")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/birthday-party/">{{
                        $t("message.nav.birthday")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/junk-catering/">{{
                        $t("message.nav.boat")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/wedding-catering/">{{
                        $t("message.nav.wedding")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/halloween/">{{
                        $t("message.nav.halloween")
                      }}</router-link>
                    </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown>
                <div class="el-dropdown-link">{{ $t("message.nav.dishes") }}</div>
                <el-dropdown-menu slot="dropdown">
                  <template v-if="this.$i18n.locale === 'zh'">
                    <el-dropdown-item>
                      <router-link to="/chinese-catering/">{{
                        $t("message.nav.chinese")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/western-catering/">{{
                        $t("message.nav.western")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/thai-catering/">{{
                        $t("message.nav.thai")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/vegetarian-catering/">{{
                        $t("message.nav.vegetarian")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/bento/">{{
                        $t("message.nav.bett")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/snack-catering">{{
                          $t("message.nav.snacks")
                        }}</router-link>
                    </el-dropdown-item>
                  </template>
                  <template v-else>
                    <el-dropdown-item>
                      <router-link to="/en/chinese-catering/">{{
                        $t("message.nav.chinese")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/western-catering/">{{
                        $t("message.nav.western")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/thai-catering/">{{
                        $t("message.nav.thai")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/vegetarian-catering/">{{
                        $t("message.nav.vegetarian")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/bento/">{{
                        $t("message.nav.bett")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/snack-catering">{{
                          $t("message.nav.snacks")
                        }}</router-link>
                    </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown>
                <div class="el-dropdown-link">{{ $t("message.nav.area") }}</div>
                <el-dropdown-menu slot="dropdown">
                  <template v-if="this.$i18n.locale === 'zh'">
                    <el-dropdown-item>
                      <router-link to="/central-and-western/">{{
                        $t("message.nav.area1")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/eastern/">{{
                        $t("message.nav.area2")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/wan-chai/">{{
                        $t("message.nav.area3")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/kwun-tong/">{{
                        $t("message.nav.area4")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/sham-shui-po/">{{
                        $t("message.nav.area5")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/yau-tsim-mong/">{{
                        $t("message.nav.area6")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/kwai-tsing/">{{
                        $t("message.nav.area7")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/sai-kung/">{{
                        $t("message.nav.area8")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/sha-tin/">{{
                        $t("message.nav.area9")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/tsuen-wan/">{{
                        $t("message.nav.area10")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/tuen-mun/">{{
                        $t("message.nav.area11")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/yuen-long/">{{
                        $t("message.nav.area12")
                      }}</router-link>
                    </el-dropdown-item>
                  </template>
                  <template v-else>
                    <el-dropdown-item>
                      <router-link to="/en/central-and-western/">{{
                        $t("message.nav.area1")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/eastern/">{{
                        $t("message.nav.area2")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/wan-chai/">{{
                        $t("message.nav.area3")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/kwun-tong/">{{
                        $t("message.nav.area4")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/sham-shui-po/">{{
                        $t("message.nav.area5")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/yau-tsim-mong/">{{
                        $t("message.nav.area6")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/kwai-tsing/">{{
                        $t("message.nav.area7")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/sai-kung/">{{
                        $t("message.nav.area8")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/sha-tin/">{{
                        $t("message.nav.area9")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/tsuen-wan/">{{
                        $t("message.nav.area10")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/tuen-mun/">{{
                        $t("message.nav.area11")
                      }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/en/yuen-long/">{{
                        $t("message.nav.area12")
                      }}</router-link>
                    </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="h-bottom-r">
              <!-- <router-link to="/cart">
                <el-badge :value="numInCart" :max="10" class="item">
                  <i class="el-icon-shopping-cart-full"></i>
                </el-badge>
              </router-link>-->
              <el-button @click="dialogVisible = true" size="mini">{{
                $t("message.nav.btn1")
              }}</el-button>
              <!-- <template v-if="this.$i18n.locale === 'zh'">
                <router-link to="/menu/">
                  <el-button size="mini" type="success">{{
                    $t("message.nav.btn2")
                  }}</el-button>
                </router-link>
              </template>
              <template v-else>
                <router-link to="/en/menu/">
                  <el-button size="mini" type="success">{{
                    $t("message.nav.btn2")
                  }}</el-button>
                </router-link>
              </template> -->
              <router-link to="/gift/">
                <span class="gift" style="position:relative">
                  <el-button size="mini" type="success">
                    {{$t("message.nav.btn4")}}
                  </el-button>
                  <img class="gift-img" src="../assets/images/gift-icon.png" alt="">
                </span>
              </router-link>
              <!-- <a href="https://blogs.cateraway.com/">
                <el-button size="mini" type="success">
                  {{$t("message.nav.btn3")}}
                </el-button>
              </a> -->
            </div>
          </div>
          <div class="lang">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link" v-if="language === 'zh'">
                中文<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <span class="el-dropdown-link" v-else>
                English<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="drop1">
                  <router-link
                    :to="{ path: this.$route.path.replace('/en', '') }"
                    >中文</router-link
                  >
                </el-dropdown-item>
                <el-dropdown-item @click.native="drop2">
                  <router-link
                    :to="{ path: '/en' + this.$route.path.replace('/en', '') }"
                    >English</router-link
                  >
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <!-- 移动端的头部 -->
      <div class="phone-header-top">
        <p :class="{ topC: show1 }">
          {{ $t("message.christmas.titleZH") }}
          <template v-if="this.$i18n.locale === 'zh'">
            <router-link to="/menu/"
              ><el-button type="primary" size="mini"
                >{{ $t("message.topbtn") }}
              </el-button></router-link
            >
          </template>
          <template v-else>
            <router-link to="/en/menu/"
              ><el-button type="primary" size="mini"
                >{{ $t("message.topbtn") }}
              </el-button></router-link
            >
          </template>
        </p>
        <div class="navlog">
          <template v-if="this.$i18n.locale === 'zh'">
            <router-link to="/">
              <img
                src="../assets/images/pc_nav_logo.png"
                alt
                width="85px"
                height="55px"
              />
            </router-link>
          </template>
          <template v-else>
            <router-link to="/en/">
              <img
                src="../assets/images/pc_nav_logo.png"
                alt
                width="100px"
                height="55px"
              />
            </router-link>
          </template>
        </div>
        <div class="top">
          <i class="el-icon-s-fold" @click="chil"></i>
        </div>
        <!-- 二级菜单 -->
        <div class="chil" :class="{ child: childis }">
          <template v-if="this.$i18n.locale === 'zh'">
            <router-link to="/">
              <p>
                <i class="el-icon-tickets"></i>
                <span style="display: inline-block; margin-left: 5%">{{
                  $t("message.nav.index")
                }}</span>
              </p>
            </router-link>
            <router-link to="/menu/">
              <p>
                <i class="el-icon-alarm-clock"></i>
                <span style="display: inline-block; margin-left: 5%">{{
                  $t("message.nav.attend")
                }}</span>
              </p>
            </router-link>
            <router-link to="/equiry/">
              <p>
                <i class="el-icon-user"></i>
                <span style="display: inline-block; margin-left: 5%">{{
                  $t("message.nav.activity")
                }}</span>
              </p>
            </router-link>
            <router-link to="/client/">
              <p>
                <i class="el-icon-connection"></i>
                <span style="display: inline-block; margin-left: 5%">{{
                  $t("message.client.nav")
                }}</span>
              </p>
            </router-link>
            <router-link to="/corporate-catering/">
              <p>
                <i class="el-icon-trophy"></i>
                <span style="display: inline-block; margin-left: 5%">{{
                  $t("message.nav.cooperation")
                }}</span>
              </p>
            </router-link>
            <router-link to="/contact/">
              <p>
                <i class="el-icon-phone-outline"></i>
                <span style="display: inline-block; margin-left: 5%">{{
                  $t("message.nav.contact")
                }}</span>
              </p>
            </router-link>
            <router-link to="/gift/">
              <p>
                <i class="el-icon-shopping-bag-1"></i>
                <span style="display: inline-block; margin-left: 5%">
                  送禮專區
                </span>
              </p>
            </router-link>
            <!-- <a href="https://blogs.cateraway.com/">
              <p>
                <i class="el-icon-edit-outline"></i>
                <span style="display: inline-block; margin-left: 5%">
                  {{$t("message.nav.btn3")}}
                </span>
              </p>
            </a> -->
          </template>
          <template v-else>
            <router-link to="/en/">
              <p>
                <i class="el-icon-tickets"></i>
                <span style="display: inline-block; margin-left: 5%">{{
                  $t("message.nav.index")
                }}</span>
              </p>
            </router-link>
            <router-link to="/en/menu/">
              <p>
                <i class="el-icon-alarm-clock"></i>
                <span style="display: inline-block; margin-left: 5%">{{
                  $t("message.nav.attend")
                }}</span>
              </p>
            </router-link>
            <router-link to="/en/equiry/">
              <p>
                <i class="el-icon-user"></i>
                <span style="display: inline-block; margin-left: 5%">{{
                  $t("message.nav.activity")
                }}</span>
              </p>
            </router-link>
            <router-link to="/en/client/">
              <p>
                <i class="el-icon-connection"></i>
                <span style="display: inline-block; margin-left: 5%">{{
                  $t("message.client.nav")
                }}</span>
              </p>
            </router-link>
            <router-link to="/en/corporate-catering/">
              <p>
                <i class="el-icon-trophy"></i>
                <span style="display: inline-block; margin-left: 5%">{{
                  $t("message.nav.cooperation")
                }}</span>
              </p>
            </router-link>
            <router-link to="/en/contact/">
              <p>
                <i class="el-icon-phone-outline"></i>
                <span style="display: inline-block; margin-left: 5%">{{
                  $t("message.nav.contact")
                }}</span>
              </p>
            </router-link>
            <router-link to="/en/gift/">
              <p>
                <i class="el-icon-shopping-bag-1"></i>
                <span style="display: inline-block; margin-left: 5%">
                  {{$t("message.nav.btn4")}}
                </span>
              </p>
            </router-link>
            <!-- <a href="https://blogs.cateraway.com/">
              <p>
                <i class="el-icon-shopping-bag-1"></i>
                <span style="display: inline-block; margin-left: 5%">
                  {{$t("message.nav.btn3")}}
                </span>
              </p>
            </a> -->
          </template>
          <div style="text-align: center">
            <el-dropdown>
              <div class="el-dropdown-link">{{ $t("message.nav.party") }}</div>
              <el-dropdown-menu slot="dropdown">
                <template v-if="this.$i18n.locale === 'zh'">
                  <el-dropdown-item>
                    <router-link to="/party-food/">{{
                      $t("message.nav.party")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/christmas-party/">{{
                      $t("message.nav.christmas")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/birthday-party/">{{
                      $t("message.nav.birthday")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/junk-catering/">{{
                      $t("message.nav.boat")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/wedding-catering/">{{
                      $t("message.nav.wedding")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/halloween/">{{
                      $t("message.nav.halloween")
                    }}</router-link>
                  </el-dropdown-item>
                </template>
                <template v-else>
                  <el-dropdown-item>
                    <router-link to="/en/party-food/">{{
                      $t("message.nav.party")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/christmas-party/">{{
                      $t("message.nav.christmas")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/birthday-party/">{{
                      $t("message.nav.birthday")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/junk-catering/">{{
                      $t("message.nav.boat")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/wedding-catering/">{{
                      $t("message.nav.wedding")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/halloween/">{{
                      $t("message.nav.halloween")
                    }}</router-link>
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown>
              <div class="el-dropdown-link">{{ $t("message.nav.dishes") }}</div>
              <el-dropdown-menu slot="dropdown">
                <template v-if="this.$i18n.locale === 'zh'">
                  <el-dropdown-item>
                    <router-link to="/chinese-catering/">{{
                      $t("message.nav.chinese")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/western-catering/">{{
                      $t("message.nav.western")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/thai-catering/">{{
                      $t("message.nav.thai")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/vegetarian-catering/">{{
                      $t("message.nav.vegetarian")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/bento/">{{
                      $t("message.nav.bett")
                    }}</router-link>
                  </el-dropdown-item>
                </template>
                <template v-else>
                  <el-dropdown-item>
                    <router-link to="/en/chinese-catering/">{{
                      $t("message.nav.chinese")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/western-catering/">{{
                      $t("message.nav.western")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/thai-catering/">{{
                      $t("message.nav.thai")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/vegetarian-catering/">{{
                      $t("message.nav.vegetarian")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/bento/">{{
                      $t("message.nav.bett")
                    }}</router-link>
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown>
              <div class="el-dropdown-link">{{ $t("message.nav.area") }}</div>
              <el-dropdown-menu slot="dropdown">
                <template v-if="this.$i18n.locale === 'zh'">
                  <el-dropdown-item>
                    <router-link to="/central-and-western/">{{
                      $t("message.nav.area1")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/eastern/">{{
                      $t("message.nav.area2")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/wan-chai/">{{
                      $t("message.nav.area3")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/kwun-tong/">{{
                      $t("message.nav.area4")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/sham-shui-po/">{{
                      $t("message.nav.area5")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/yau-tsim-mong/">{{
                      $t("message.nav.area6")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/kwai-tsing/">{{
                      $t("message.nav.area7")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/sai-kung/">{{
                      $t("message.nav.area8")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/sha-tin/">{{
                      $t("message.nav.area9")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/tsuen-wan/">{{
                      $t("message.nav.area10")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/tuen-mun/">{{
                      $t("message.nav.area11")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/yuen-long/">{{
                      $t("message.nav.area12")
                    }}</router-link>
                  </el-dropdown-item>
                </template>
                <template v-else>
                  <el-dropdown-item>
                    <router-link to="/en/central-and-western/">{{
                      $t("message.nav.area1")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/eastern/">{{
                      $t("message.nav.area2")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/wan-chai/">{{
                      $t("message.nav.area3")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/kwun-tong/">{{
                      $t("message.nav.area4")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/sham-shui-po/">{{
                      $t("message.nav.area5")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/yau-tsim-mong/">{{
                      $t("message.nav.area6")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/kwai-tsing/">{{
                      $t("message.nav.area7")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/sai-kung/">{{
                      $t("message.nav.area8")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/sha-tin/">{{
                      $t("message.nav.area9")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/tsuen-wan/">{{
                      $t("message.nav.area10")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/tuen-mun/">{{
                      $t("message.nav.area11")
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/en/yuen-long/">{{
                      $t("message.nav.area12")
                    }}</router-link>
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="lang">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link" v-if="language === 'zh'">
                中文<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <span class="el-dropdown-link" v-else>
                English<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="drop1">
                  <router-link
                    :to="{ path: this.$route.path.replace('/en', '') }"
                    >中文</router-link
                  >
                </el-dropdown-item>
                <el-dropdown-item @click.native="drop2">
                  <router-link
                    :to="{ path: '/en' + this.$route.path.replace('/en', '') }"
                    >English</router-link
                  >
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <p style="text-align: center">
            <el-button @click="dialogVisible = true" type="mini">{{
              $t("message.nav.btn1")
            }}</el-button>
            <router-link
              :to="{ path: '/menu/', params: { lang: this.$i18n.locale } }"
            >
              <el-button type="mini">{{ $t("message.nav.btn2") }}</el-button>
            </router-link>
          </p>
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible" width="90%">
        <el-form
          :label-position="labelPosition"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          size="mini"
        >
          <p class="banner-call1">{{ $t("message.dialog.title1") }}</p>
          <el-form-item :label="$t('message.dialog.name')" prop="name">
            <el-input
              :placeholder="$t('message.dialog.names')"
              v-model="ruleForm.name"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.email')" prop="email">
            <el-input
              :placeholder="$t('message.dialog.emails')"
              v-model="ruleForm.email"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.phone')" prop="phone">
            <el-input
              :placeholder="$t('message.dialog.phones')"
              v-model="ruleForm.phone"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.company')" prop="con">
            <el-input
              v-model="ruleForm.con"
              :placeholder="$t('message.dialog.companys')"
            ></el-input>
          </el-form-item>
          <p class="banner-call1">{{ $t("message.dialog.title2") }}</p>
          <el-form-item :label="$t('message.dialog.eventDate')" prop="date1">
            <el-date-picker
              type="date"
              :placeholder="$t('message.dialog.eventDates')"
              :picker-options="pickerOptions0"
              v-model="ruleForm.date1"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.eventTime')" prop="date2">
            <el-input
              :placeholder="$t('message.dialog.eventTimes')"
              v-model="ruleForm.date2"
              style="width: 100%"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.dialog.eventyLocation')"
            prop="location"
          >
            <el-input
              :placeholder="$t('message.dialog.eventyLocations')"
              v-model="ruleForm.location"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.dialog.eumberOfGuests')"
            prop="number"
          >
            <el-input-number v-model="ruleForm.number"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.budget')" prop="budget">
            <el-input
              :placeholder="$t('message.dialog.budgets')"
              v-model="ruleForm.budget"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.requiredFoods')" prop="food">
            <el-input
              v-model="ruleForm.food"
              :placeholder="$t('message.dialog.requiredFoods')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.dialog.servingstyle')"
            prop="region1"
          >
            <el-input
              v-model="ruleForm.region1"
              :placeholder="$t('message.dialog.servingstyles')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.bervage')" prop="Drink">
            <el-input
              v-model="ruleForm.Drink"
              :placeholder="$t('message.dialog.bervages')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.waiters')" prop="Waiter">
            <el-input
              v-model="ruleForm.Waiter"
              :placeholder="$t('message.dialog.waiterss')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.dialog.requiredEquipment')"
            prop="region2"
          >
            <el-input
              v-model="ruleForm.region2"
              :placeholder="$t('message.dialog.requiredEquipments')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.dialog.otherRemarks')" prop="Claim">
            <el-input
              v-model="ruleForm.Claim"
              :placeholder="$t('message.dialog.otherRemarkss')"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <a
            :href="href"
            style="color: #fff; text-decoration: none"
            @click="show('ruleForm')"
          >
            <el-button type="primary">{{
              $t("message.dialog.confirm")
            }}</el-button>
          </a>
          <el-button @click="dialogVisible = false">{{
            $t("message.dialog.cancel")
          }}</el-button>
        </span>
      </el-dialog>
    </header>
    <div class="bg" @click="chil"></div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      show1: true,
      language: "zh",
      childis: false,
      options: [
        {
          value: "zh",
          label: "中文",
        },
        {
          value: "en",
          label: "English",
        },
      ],
      value: "zh",
      lang: [
        {
          value: "zh",
          label: "中文",
        },
        {
          value: "en",
          label: "English",
        },
      ],
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() - 259200000 < Date.now() - 8.64e7;
        },
      },
      href: "",
      dialogVisible: false,
      PartyA: false,
      // num: 1,
      labelPosition: "right",
      i: true,
      tableData: [
        {
          date: "Deluxe 30人精緻套餐",
          offer: "",
          price: "3,840.00",
          num: "1",
          sum: "3,840.00",
        },
        {
          date: "Deluxe 30人精緻套餐",
          offer: "",
          price: "3,840.00",
          num: "1",
          sum: "3,840.00",
        },
        {
          date: "Deluxe 30人精緻套餐",
          offer: "",
          price: "3,840.00",
          num: "1",
          sum: "3,840.00",
        },
        {
          date: "Deluxe 30人精緻套餐",
          offer: "",
          price: "3,840.00",
          num: "1",
          sum: "3,840.00",
        },
      ],
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      ruleForm: {
        name: "",
        email: "",
        phone: "",
        con: "",
        date1: "",
        date2: "",
        location: "",
        number: "",
        budget: "",
        food: "",
        Drink: "",
        Waiter: "",
        Claim: "",
        region1: "",
        region2: "",
      },
      rules: {
        name: [
          { required: true, message: "請輸入您的稱呼", trigger: "blur" },
          { min: 1, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        email: [
          { required: true, message: "請輸入電郵", trigger: "blur" },
          { type: "email", message: "格式不對", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "請輸入聯絡方式", trigger: "blur" },
          {
            pattern:
              /^[1][3-8]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/,
            message: "請輸入正確的手機號碼格式",
          },
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "請選擇日期",
            trigger: "change",
          },
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "請選擇時間",
            trigger: "change",
          },
        ],
        location: [
          { required: true, message: "請輸入活動地點", trigger: "blur" },
        ],
        number: [
          { required: true, message: "請輸入貴賓人數", trigger: "blur" },
        ],
        budget: [{ required: true, message: "請輸入預算", trigger: "blur" }],
        food: [{ required: true, message: "請輸入所需食物", trigger: "blur" }],
      },
    };
  },
  computed: {
    numInCart() {
      var nums = 0;
      if (this.$store.getters.getCartItems.length > 0) {
        for (var item of this.$store.getters.getCartItems) {
          nums = nums + item.quantity;
        }
      }
      return nums;
    },
  },
  methods: {
    drop1() {
      this.$i18n.locale = "zh";
    },
    drop2() {
      this.$i18n.locale = "en";
    },
    chil() {
      if (this.i === true) {
        $(".phone-header-top").css("overflow", "inherit");
        this.i = false;
      } else if (this.i === false) {
        $(".phone-header-top").css("overflow", "hidden");
        this.i = true;
      }
    },
    show(formName) {
      this.href =
        "https://api.whatsapp.com/send?phone=85264586539&text=hello%20到會家,我想瞭解一些合作的相關事宜%0A稱呼:" +
        this.ruleForm.name +
        "%0A電郵：" +
        this.ruleForm.email +
        "%0A電話：" +
        this.ruleForm.phone +
        "%0A公司：" +
        this.ruleForm.con +
        "%0A日期：" +
        this.$moment(this.ruleForm.date1).format("YYYY-MM-DD") +
        "%0A時間：" +
        this.ruleForm.date2 +
        "%0A地點：" +
        this.ruleForm.location +
        "%0A貴賓人數：" +
        this.ruleForm.number +
        "%0A預算：" +
        this.ruleForm.budget +
        "%0A所需食物：" +
        this.ruleForm.food +
        "%0A食物供應形式：" +
        this.ruleForm.region1 +
        "%0A飲品：" +
        this.ruleForm.Drink +
        "%0A待應生：" +
        this.ruleForm.Waiter +
        "%0A設備要求：" +
        this.ruleForm.region2 +
        "%0A特別要求/安排：" +
        this.ruleForm.Claim +
        "！😋";
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          return false;
        }
      });
    },
    // 购物车数量显示
    badge() {
      if (this.numInCart === 0) {
        $(".el-badge__content").css("display", "none");
      } else {
        $(".el-badge__content").css("display", "block");
      }
    },
  },
  mounted() {
    if (this.$route.path.indexOf("/en/") !== -1) {
      this.$i18n.locale = "en";
      this.language = "en";
      this.value = "en";
    } else {
      this.$i18n.locale = "zh";
      this.language = "zh";
      this.value = "zh";
    }
  },
  // watch: {
  //   language: function(val) {
  //     localStorage.setItem("lang", val);
  //     if (val === "en") {
  //       this.$i18n.locale = "en";
  //       this.$router.push({
  //         path: "/en" + this.$route.path.replace("/en", ""),
  //         query: {
  //           ...this.$route.query
  //         }
  //       });
  //     }
  //     if (val === "zh") {
  //       this.$i18n.locale = "zh";
  //       this.$router.push({
  //         path: this.$route.path.replace("/en", ""),
  //         query: {
  //           ...this.$route.query
  //         }
  //       });
  //     }
  //     Vue.set(this.lang, "zh", { label: this.$t("message.zh"), value: "zh" });
  //     Vue.set(this.lang, "en", { label: this.$t("message.en"), value: "en" });
  //   },
  //   value: function(val) {
  //     localStorage.setItem("lang", val);
  //     // val === 0 ? this.$i18n.locale = 'zh' : this.$i18n.locale = 'en'
  //     if (val === "en") {
  //       this.$i18n.locale = "en";
  //       this.$router.push({
  //         path: "/en" + this.$route.path.replace("en/", "")
  //       });
  //     }
  //     if (val === "zh") {
  //       this.$i18n.locale = "zh";
  //       this.$router.push({
  //         path: this.$route.path.replace("/en", "")
  //       });
  //       // this.language = 'zh'
  //     }
  //     Vue.set(this.lang, "zh", { label: this.$t("message.zh"), value: "zh" });
  //     Vue.set(this.lang, "en", { label: this.$t("message.en"), value: "en" });
  //   },
  //   $route: {
  //     handler: function(route) {
  //       if (route.path.indexOf("/en/") === -1) {
  //         this.$i18n.locale = "zh";
  //       } else {
  //         this.$i18n.locale = "en";
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  updated() {
    this.badge();
    this.$i18n.locale === "zh"
      ? (this.language = "zh")
      : (this.language = "en");
    if (this.$i18n.locale === "zh") {
      this.show1 = true;
    } else {
      this.show1 = false;
    }
  },
};
</script>

<style scoped>
@import "../components/common/font/font.css";
/* 页头 */
.header .header-bottom > p {
  height: 40px;
  line-height: 40px;
  background: #ff5809;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
}
.header .header-bottom > p button {
  margin-left: 20px;
  border: 1px solid #fff;
  background: transparent;
}
.header .header-bottom > p a {
  color: #fff;
}
a {
  text-decoration: none;
}
.phone-header-top {
  line-height: 60px;
  display: none;
  height: 80px;
  background: white;
}
.phone-header-top > p {
  height: 20px;
  line-height: 20px;
  background: #ff5809;
  text-align: center;
  color: #ffffff;
}
.phone-header-top > div:nth-child(2) {
  float: left;
  padding: 0 5%;
  color: #eb6410;
}
.phone-header-top > div:nth-child(3) {
  float: right;
  width: 15%;
  margin-top: 5px;
}
.phone-header-top > div > i,
.phone-header-top > div > a > i {
  border: 2px solid;
  border-radius: 50%;
  color: #eb6410;
  font-size: 1.7rem;
  text-align: center;
  margin: 0 6%;
  padding: 5%;
}
.phone-header-top > div > i:nth-child(3) {
  color: black;
}
.bg {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 5;
  background: rgba(20, 20, 21, 0.5);
}
header {
  width: 100%;
  height: 110px;
  position: fixed;
  z-index: 99;
  top: 0;
}
.header-bottom {
  background-color: #fff;
  height: 110px;
  /* line-height: 80px; */
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction:column;
}
.header .center {
  width: 70%;
  height: 100%;
  margin: auto;
  overflow: hidden;
  display: flex;
  justify-content:space-between;
  align-items:center;
}
.gift-img{
  position: absolute;
  width: 50px;
  top: -30px;
  right: -20px;
}
.h-bottom-l {
  float: left;
  display: flex;
  align-items:center;
}
.h-bottom-l ul,
.h-bottom-r a > span {
  font-size: 0.85rem;
  color: #eb6410;
}
.h-bottom-r span {
  cursor: pointer;
  font-size: 13px;
  font-weight: 300;
  margin-right: 0.5rem;
}
.h-bottom-r > span a {
  text-decoration: none;
  color: #eb6410;
}
.h-bottom-r i {
  font-size: 1.5rem;
  color: #a1a1a1;
  margin-right: 1rem;
  position: relative;
  top: 5px;
}
.h-bottom-l ul:nth-child(2) li:hover {
  border: 1px solid;
}
.h-bottom-l ul:nth-child(2) li {
  border: 1px solid white;
  margin: 0 1rem;
  height: 30px;
  line-height: 30px;
  padding: 0 5px;
  text-align: center;
  color: #eb6410;
  border-radius: 5%;
  font-size: 0.86rem;
}
/* .h-bottom-l ul a {
  color: black;
} */
.h-bottom-r {
  float: left;
  margin-left: 1rem;
}
.header .header-bottom ul {
  float: left;
}
.header .h-bottom-l ul li {
  display: inline-block;
}
.el-button--success {
  border: 1px solid #eb6410;
  background: #eb6410;
}
.h-r {
  float: right;
  color: #a1a1a1;
}
.h-r > i,
.h-r a i {
  font-weight: bold;
  font-size: 1.2rem;
  margin: 0 0.8rem;
  color: #a1a1a1;
}
.h-r > span {
  font-weight: bold;
  font-size: 0.9rem;
  margin: 0 0.8rem;
}
.banner-call1 {
  text-align: center;
  font-weight: 200;
  color: #eb6410;
  letter-spacing: 0;
  /* text-shadow: 0px 1px 0px #999, 0px 2px 0px #888, 0px 3px 0px #777, 0px 4px 0px #666, 0px 5px 0px #555, 0px 6px 0px #444, 0px 7px 0px #333, 0px 8px 7px #001135; */
  margin: 0 0 3% 0;
  font-size: 1.1rem;
}
.header-bottom button,
.chil p button {
  color: white;
  border: 1px solid #eb6410;
  background: #eb6410;
}
.el-dropdown {
  padding: 0 5px;
  box-sizing: border-box;
  margin: 0 1rem;
  border: 1px solid white;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #eb6410;
  border-radius: 5%;
  font-size: 0.86rem;
}
.el-dropdown:hover {
  cursor: pointer;
  border: 1px solid #eb6410;
}
/* 移动端 */
@media (max-width: 1666px) {
  .h-bottom-l ul:nth-child(2) li {
    margin: 0 0.7rem;
  }
  .el-dropdown {
    margin: 0 0.7rem;
  }
}
@media (max-width: 1580px) {
  .header .center {
    width: 85%;
  }
}
@media (max-width: 1390px) {
  .header .center {
    width: 90%;
  }
}
@media (max-width: 1300px) {
  .header .center {
    width: 97%;
  }
}
@media (max-width: 1145px) {
  .header .h-bottom-r {
    margin-left: 10px;
  }
  .h-bottom-l ul:nth-child(2) li {
    margin: 0;
  }
  .header .el-dropdown {
    margin: 0 0.5rem;
  }
}
@media (max-width: 986px) {
  .header .el-dropdown {
    margin: 0 0.2rem;
  }
}
@media (max-width: 932px) {
  .header .el-dropdown {
    margin: 0 0.2rem;
  }
  .header .h-bottom-l ul:nth-child(1) a img {
    /* width: 80px; */
    height: 100%;
    position: relative;
    top: 7px;
  }
  .header .el-dropdown {
    padding: 0;
    margin: 0 0.1rem;
  }
}
@media (max-width: 880px) {
  .lang {
    text-align: center;
    width: 100%;
  }
  .phone-header-top {
    overflow: hidden;
    position: relative;
    display: block;
  }
  .phone-header-top > div > i,
  .phone-header-top > div > a > i {
    font-size: 2rem;
  }
  .chil {
    border-top: 1px solid #eee;
    position: absolute;
    width: 100%;
    background: #fff;
    z-index: 4;
    top: 110px;
    border-bottom: 1px solid #eee;
  }
  .chil p:nth-child(6) {
    text-align: center;
  }
  .chil p {
    box-sizing: border-box;
    padding: 0 1.5rem;
    font-size: 0.89rem;
    color: #515154;
    font-weight: 400;
  }
  .chil span {
    text-decoration: none;
    color: #eb6410;
  }
  header,
  .header .phone-header-top {
    height: 110px;
  }
  .header .phone-header-top > p {
    padding: 0 20px;
    height: 50px;
    line-height: 50px;
    font-size: 13px;
  }
  .header .phone-header-top > p a {
    margin: 0 0 0 20px;
  }
  .header .phone-header-top > p button {
    border: 1px solid #fff;
  }
  .header-bottom {
    display: none;
  }
  .header-top {
    display: none;
  }
  .step {
    width: 95%;
    margin: 3% auto;
  }
  .center {
    width: 100%;
  }
  .s-main > div {
    float: none;
    margin: auto;
  }
  .s-main > div:nth-child(1),
  .s-main > div:nth-child(2) {
    width: 95%;
  }
  .s-bottom,
  .s-top {
    width: 95%;
    margin: 3% auto;
  }
  .s-top > div:nth-child(2) {
    display: none;
  }
  .s-top > div:nth-child(3) {
    display: block;
    overflow: hidden;
    background: #fff;
  }
  .s-top > div:nth-child(3) span {
    font-size: 12px;
    line-height: 28px;
  }
  .s-top > div:nth-child(3) > div {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    box-sizing: border-box;
    padding: 5% 2%;
  }
  .el-steps--simple {
    padding: 13px 4%;
  }
  .top .el-dialog {
    width: 100% !important;
    margin: 0 !important;
  }
  .top .el-dialog__body {
    padding: 0 !important;
  }
  header .el-dialog {
    margin: 0 !important;
  }
}
@media (max-width: 768px) {
  header,
  .header .phone-header-top {
    height: 110px;
  }
}
@media (max-width: 565px) {
  .header .phone-header-top > .topC {
    padding: 0 20px;
    height: 75px;
    line-height: 35px;
    font-size: 13px;
  }
  .header .phone-header-top > p {
    padding: 0 5px;
    height: 75px;
    line-height: 20px;
    font-size: 13px;
  }
  .chil {
    top: 135px;
  }
  header,
  .header .phone-header-top {
    height: 135px;
  }
  .header .phone-header-top > p a {
    display: block;
  }
}
</style>
<style>
.header .h-bottom-l ul:nth-child(1) a {
  display: block;
  font-size: 13px;
}
.header .h-bottom-l ul:nth-child(1) a img {
  /* width: 93px; */
  height: 100%;
}
.header .el-dialog__body label {
  width: 140px !important;
}
.header .el-form-item__content {
  margin-left: 150px !important;
}
@media (max-width: 820px) {
  .header .el-dialog__footer {
    text-align: center !important;
  }
  .header .el-dialog {
    width: 100% !important;
    margin: 0 !important;
  }
  .header .el-dialog__body {
    padding: 35px 20px 35px 0;
  }
  .phone-header-top .el-dialog {
    margin: 7vh 0 0 0;
  }
  .phone-header-top .el-button.el-button--primary {
    border: 1px solid #fff;
    background: transparent;
  }
}
.header .el-radio {
  margin-right: 0;
}
.el-form-item__label {
  font-size: 13px !important;
}
.v-modal {
  display: none;
}
.el-dialog__footer {
  text-align: center;
}
.el-button--primary {
  border: 1px solid #eb6410;
  background: #eb6410;
}
.el-dropdown-menu__item {
  width: 100px;
  padding: 0;
  text-align: center;
}
.el-dropdown-menu__item a {
  color: #eb6410ed;
  display: block;
  font-family: FZCYJ;
}
.lang {
  float: right;
}
.header .el-scrollbar__wrap {
  overflow: auto;
}
.header .el-select-dropdown__wrap.el-scrollbar__wrap {
  margin-bottom: 0;
}
.header .el-select-dropdown.el-popper {
  top: 45px;
}
.header .el-badge__content.is-fixed {
  top: 20px;
  right: 25px;
}
</style>
